// Public surface of the lore layer. Import from '@/lore' (or relative '../lore').
export * from './types'
export { system404 } from './system'

import type { CelestialBody, Faction } from './types'
import { system404 } from './system'
import { dwarfPlanets } from './bodies/dwarfs'

/** Every body in the system, flattened (star + planets + their moons), plus the
 *  consolidated dwarf-planets entry so getBodyById('dwarfs') resolves. */
export const allBodies: CelestialBody[] = [
  system404.star,
  ...system404.bodies,
  ...system404.bodies.flatMap((b) => b.moons ?? []),
  dwarfPlanets,
]

export function getBodyById(id: string): CelestialBody | undefined {
  return allBodies.find((b) => b.id === id)
}

/** Bodies shown in the lorebook sidebar + landing grid. The three individual
 *  dwarfs are hidden in favor of the single shared 'dwarfPlanets' entry. */
export const lorebookBodies: CelestialBody[] = [
  system404.star,
  ...system404.bodies.filter((b) => !(b.type === 'dwarf' && b.id !== 'dwarfs')),
  dwarfPlanets,
]

/** The lorebook URL for a body. The individual dwarfs route into their section
 *  of the shared 'dwarfPlanets' page instead of their own sparse page. */
export function lorebookHref(body: CelestialBody): string {
  if (body.type === 'dwarf' && body.id !== 'dwarfs') return `/lorebook/dwarfs#${body.id}`
  return `/lorebook/${body.id}`
}

/** Every faction, flattened (parents + their subfactions). */
export const allFactions: Faction[] = [
  ...system404.factions,
  ...system404.factions.flatMap((f) => f.subfactions ?? []),
]

export function getFactionById(id: string): Faction | undefined {
  return allFactions.find((f) => f.id === id)
}
